import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import apiClient from '../../config/apiClient';

interface User {
  id: string;
  displayName: string;
  mail: string;
  jobTitle: string;
  department: string;
}

const UserReport: React.FC = () => {
  const { classification } = useParams<{ classification: string }>();
  const [users, setUsers] = useState<User[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchUsers = async () => {
      setLoading(true);
      try {
        const response = await apiClient.get(`/users/classification/${classification}`);
        setUsers(response.data);
      } catch (err) {
        setError('Failed to fetch users');
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
  }, [classification]);

  if (loading) return <p>Loading...</p>;
  if (error) return <p>{error}</p>;
  if (users.length === 0) return <p>No users found for classification "{classification}".</p>;

  return (
    <div>
      <h2 className="text-lg font-bold mb-4">User Report - {classification}</h2>
      <table className="min-w-full border border-gray-200 text-center">
        <thead>
          <tr>
            <th className="px-4 py-2 border-b">ID</th>
            <th className="px-4 py-2 border-b">Name</th>
            <th className="px-4 py-2 border-b">Email</th>
            <th className="px-4 py-2 border-b">Job Title</th>
            <th className="px-4 py-2 border-b">Department</th>
          </tr>
        </thead>
        <tbody>
          {users.map((user) => (
            <tr key={user.id}>
              <td className="px-4 py-2 border-b">{user.id}</td>
              <td className="px-4 py-2 border-b">{user.displayName}</td>
              <td className="px-4 py-2 border-b">{user.mail}</td>
              <td className="px-4 py-2 border-b">{user.jobTitle || 'N/A'}</td>
              <td className="px-4 py-2 border-b">{user.department || 'N/A'}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default UserReport;
